var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.26,12.74a1,1,0,1,0,1.47-1.48L9.21,7.73A1,1,0,0,0,7.73,9.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.07,4.92A10,10,0,0,0,12,2h0a1,1,0,0,0-1,1V5.78a1,1,0,1,0,2,0V4.12A7.93,7.93,0,1,1,6.37,6.37c.12-.12.5-.44.79-.67L5.71,4.24a4.89,4.89,0,0,0-.79.69,10,10,0,1,0,14.15,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.c076e987db024a52c302d1f0612c0b97.svg";
export { ForwardRef as ReactComponent };